import Vue from 'vue'
import { getSSOProviderInfo } from '@/api/auth'
import LoginModal from '@/components/LoginModal'
import router from './'
import store from '@/store'

let pendingLoginModalPromise = null

export function showLoginModal() {
    if (pendingLoginModalPromise) {
      return pendingLoginModalPromise
    }

    pendingLoginModalPromise = (async () => {
      let ssoProviderInfo = {}
      try {
        ssoProviderInfo = await getSSOProviderInfo()
      } catch (err) {
        pendingLoginModalPromise = null
        throw {error: err, message: 'Failed to get SSO provider info'}
      }

      return new Promise((resolve, reject) => {
        const LoginModalCtor = Vue.extend(LoginModal)

        const { email, sso_provider_ids, enforce_sso } = store.state.user.user

        const loginModal = new LoginModalCtor({
          propsData: {
            email: email,
            ssoProviders: sso_provider_ids || [],
            ssoProviderInfo,
            enforceSSO: enforce_sso
          }
        })

        loginModal.$on('login-success', () => {
          pendingLoginModalPromise = null
          return resolve({message: 'success'})
        })
        loginModal.$on('login-dismissed', () => {
          pendingLoginModalPromise = null
          return reject({message: 'Login error or login dismissed'})
        })

        loginModal.$parent = router.app.$children[0]
        loginModal.$mount()
        router.app.$el.appendChild(loginModal.$el)
      })
    })()

    return pendingLoginModalPromise
  }